import CheckIcon from '@mui/icons-material/Check';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import React from 'react';

const UpdateSavShippingConfirmModal = ({
  isOpen,
  handleClose,
  handleConfirm,
  formData,
  originalData,
  confirmLoading,
}) => {
  const formatDate = (date) => {
    return date
      ? format(new Date(date), 'dd MMMM yyyy', { locale: fr })
      : 'Non définie';
  };

  const hasDateChanged =
    formData.desiredShippingDate !== originalData.desiredShippingDate;
  const hasTrackingChanged = formData.tracking !== originalData.tracking;

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirmation des modifications</DialogTitle>
      <DialogContent>
        {hasDateChanged && (
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="h6"
              color="primary"
              sx={{ fontSize: '1em', fontWeight: 'bold', mt: 1 }}
            >
              Date d&apos;expédition souhaitée
            </Typography>
            <Box
              sx={{
                backgroundColor: 'rgba(0, 0, 0, 0.02)',
                p: 1,
                borderRadius: 1,
                border: 1,
                borderColor: 'divider',
              }}
            >
              <Typography
                sx={{ textDecoration: 'line-through', color: 'text.secondary' }}
              >
                {formatDate(originalData.desiredShippingDate)}
              </Typography>
              <Typography sx={{ color: 'success.main', fontWeight: 'bold' }}>
                {formatDate(formData.desiredShippingDate)}
              </Typography>
            </Box>
          </Box>
        )}

        {hasTrackingChanged && (
          <Box>
            <Typography
              variant="h6"
              color="primary"
              sx={{ fontSize: '1em', fontWeight: 'bold', mt: 1 }}
            >
              Numéro de tracking
            </Typography>
            <Box
              sx={{
                backgroundColor: 'rgba(0, 0, 0, 0.02)',
                p: 1,
                borderRadius: 1,
                border: 1,
                borderColor: 'divider',
              }}
            >
              <Typography
                sx={{ textDecoration: 'line-through', color: 'text.secondary' }}
              >
                {originalData.tracking || 'Non défini'}
              </Typography>
              <Typography sx={{ color: 'success.main', fontWeight: 'bold' }}>
                {formData.tracking || 'Non défini'}
              </Typography>
              <Typography>
                La mise à jour du numéro de tracking passera commande en cours
                de préparation STO (le numéro de tracking restera modifiable
                après confirmation)
              </Typography>
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={confirmLoading}>
          Annuler
        </Button>
        <Button
          endIcon={
            confirmLoading ? <CircularProgress size={10} /> : <CheckIcon />
          }
          disabled={confirmLoading}
          onClick={handleConfirm}
          variant="contained"
        >
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateSavShippingConfirmModal;
